import {useSearchStore} from "@stores/useSearchStore";
import { defineNuxtPlugin, useHydration } from "nuxt/app";

export default defineNuxtPlugin(() => {
	const searchStore = useSearchStore();

	useHydration(
		'myStoreState',
		() => searchStore.pageData,
		data => searchStore.pageData = data,
	);
});